// extracted by mini-css-extract-plugin
module.exports = {"body":"ClientDataModal_body__3pDjz","header":"ClientDataModal_header__29SWf","description":"ClientDataModal_description__2FCcH","textField":"ClientDataModal_textField__zvdJx"};